module.exports = __webpack_public_path__ + "static/media/cr.7b4ebd50.svg";